<template>
  <div class="foot">
    <div class="wapc">
      <div class="fnav clearfix">
        <div class="left" v-if="menuList.length>0">
          <router-link
            :style="{display:nav.nodeIndexName=='product'||!nav.isShow?'none':''}"
            v-for="nav in menuList"
            :key="nav.nodeId"
            :to="{name:nav.pathName,params:{pId:nav.nodeId,cId:nav.hasChilds?nav.childs[0].nodeId:''}}"
            id="foot_first_url"
          >{{nav.nodeName}}</router-link>
        </div>
        <div class="right" :key="addKey">
          <router-link
            :to="{name:'about',params:{pId:aboutData.parentId,cId:aboutData.nodeId}}"
            title
          >了解我们</router-link>
          <router-link to="/contactus" title>联系我们</router-link>
          <router-link
            :to="{name:'about',params:{pId:jysjData.parentId,cId:jysjData.nodeId}}"
            title
          >经营实绩</router-link>
          <router-link to="/links" title>友情链接</router-link>
        </div>
      </div>
      <div class="fcon clearfix">
        <div class="left clearfix" v-if="contactData">
          <div class="ewm">
            <img :src="contactData.imageUrl" />
            <h5>宝钢金属微信公众号</h5>
          </div>
          <div class="txt" v-html="contactData.content">
            <!-- <h3 class="ft26">宝钢金属有限公司</h3>
            <p>上海市宝山区同济路333号5号楼</p>
            <h4>
              Tel:+86 21 26099999
              <span></span>Fax:+86 21 26099998
              <br />E-mail:baosteelmetal@baosteel.com
            </h4>
            <h5>宝钢金属微信公众号</h5>-->
          </div>
        </div>
        <div class="liuy">
          <div class="li">
            <input type="text" placeholder="姓名" id="txt_name" v-model="nameVal" />
          </div>
          <div class="li">
            <input type="text" placeholder="电话/邮箱" id="txt_contact" v-model="phoneEmialVal" />
          </div>
          <div class="li">
            <textarea placeholder="请输入内容..." id="txt_content" v-model="contentVal"></textarea>
          </div>
          <div class="buts">
            <input class="but" type="button" @click="submitFun" value="提  交" />
          </div>
        </div>
      </div>
    </div>
    <div class="footb">
      <div class="wapc clearfix" v-if="icpData" v-html="icpData.content">
        <!-- <div class="left">
          宝钢金属有限公司版权所有
          <a
            href="http://www.beian.miit.gov.cn"
            target="_blank"
            style="color:#fff"
          >沪ICP备09099023号</a>
          &nbsp;
          <span id="cnzz_stat_icon_5768887">
            <a
              href="https://www.cnzz.com/stat/website.php?web_id=5768887"
              target="_blank"
              title="站长统计"
            >站长统计</a>&nbsp;
          </span>
          ©2018 www.baosteelmetal.com; All Rights Reserved.
        </div>
        <div class="right">
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011302002719"
            title
            target="_blank"
          >
            <img src="/static/baico1.png" />公网安备 沪公网安备 31011302002719号
          </a>
        </div>-->
      </div>
    </div>
    <el-dialog
      title
      :visible.sync="dialogFlag"
      width="200px"
      :append-to-body="true"
      :modal-append-to-body="true"
      close-on-click-modal
      close-on-press-escape
      show-close
    >
      <div>
        <p>
          验证码：
          <img
            @click="getCheckCode"
            style="display:inline;width:60px;vertical-align: middle;"
            :src="'data:image/png;base64,'+vcodestr"
            alt
          />
        </p>
        <div style="padding:10px 0">
          <!-- <input style="height:24px;line-height:24px;width:50%;vertical-align: middle;" type="text" /> -->
          <el-input size="mini" v-model="checkcodeVal"></el-input>
        </div>
        <el-button type="primary" size="mini" @click="submitFeed">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getMenu, getMessageCheckCode, sendMessage } from "@/api/index";
export default {
  data() {
    return {
      addKey: 0,
      dialogFlag: false,
      vcodestr: "",
      checkcodeVal: "",
      menuList: [],
      nameVal: "",
      phoneEmialVal: "",
      contentVal: "",
      contactData: null,
      icpData: null,
      aboutData: null,
      jysjData: null
    };
  },
  created() {
    if (!localStorage.bwsteelMenus) {
      this.getMenuFun();
    } else {
      let menus = JSON.parse(localStorage.bwsteelMenus);
      this.$set(this.$data, "menuList", menus);
      this.$set(
        this.$data,
        "contactData",
        this.$utils.getChildNodeId("info", "infocontact")
      );
      this.$set(
        this.$data,
        "icpData",
        this.$utils.getChildNodeId("info", "icp")
      );
      this.$set(
        this.$data,
        "aboutData",
        this.$utils.getChildNodeId("About Us", "brief")
      );

      this.$set(
        this.$data,
        "jysjData",
        this.$utils.getChildNodeId("development", "achievement")
      );
      this.addKey++;
    }
  },
  methods: {
    getMenuFun() {
      getMenu().then(res => {
        if (res.data.code === 1000) {
          let datas = res.data.data[0].childs.map(item => {
            if (item.childs) {
              item.hasChilds = true;
            }
            item.path = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).url;
            item.pathName = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).name;
            return item;
          });
          localStorage.setItem("bwsteelMenus", JSON.stringify(datas));
          this.$set(this.$data, "menuList", datas);
          this.$set(
            this.$data,
            "contactData",
            this.$utils.getChildNodeId("info", "infocontact")
          );
          this.$set(
            this.$data,
            "icpData",
            this.$utils.getChildNodeId("info", "icp")
          );
          this.$set(
            this.$data,
            "aboutData",
            this.$utils.getChildNodeId("About Us", "brief")
          );
          this.$set(
            this.$data,
            "jysjData",
            this.$utils.getChildNodeId("development", "achievement")
          );
          this.addKey++;
        } else {
          this.$message.error("栏目获取失败！");
        }
      });
    },
    submitFun() {
      if (this.$utils.checkEmpty(this.nameVal)) {
        return this.$alert("请输入姓名！", "信息");
      }
      if (this.$utils.checkEmpty(this.phoneEmialVal)) {
        return this.$alert("请输入电话/邮箱！", "信息");
      }
      if (
        !this.$utils.checkPhone(this.phoneEmialVal) &&
        !this.$utils.checkEmail(this.phoneEmialVal)
      ) {
        return this.$alert("请输入正确的电话/邮箱！", "信息");
      }
      if (this.$utils.checkEmpty(this.contentVal)) {
        return this.$alert("请输入内容！", "信息");
      }
      this.getCheckCode();
      this.dialogFlag = true;
    },
    getCheckCode() {
      getMessageCheckCode().then(res => {
        if (res.data.code == 1000) {
          this.vcodestr = res.data.data.content;
        }
      });
    },
    submitFeed() {
      sendMessage({
        name: this.nameVal,
        phone: this.phoneEmialVal,
        email: this.phoneEmialVal,
        company: "",
        job: "",
        message: this.contentVal,
        verifyCode: this.checkcodeVal
      }).then(res => {
        if (res.data.code == 1000) {
          this.dialogFlag = false;
          this.$alert("提交成功！", "信息");
        }
      });
    }
  }
};
</script>